export default "__VITE_ASSET__BnmQvaLP__"